/* cspell:ignore മലയാളം தமிழ் */
import React, { useState } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faPrint,
  faBook,
  faLanguage,
  faChevronDown,
  faChevronUp,
  faCross,
} from "@fortawesome/free-solid-svg-icons";

const ConfessionGuidePage = () => {
  const [expandedSection, setExpandedSection] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("english");

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const languages = [
    {
      code: "english",
      name: "English",
      file: "/attachments/CONFESSION_GUIDE_ENGLISH.pdf",
    },
    {
      code: "malayalam",
      name: "മലയാളം (Malayalam)",
      file: "/attachments/CONFESSION_GUIDE_MALAYALAM.pdf",
    },
    {
      code: "tamil",
      name: "தமிழ் (Tamil)",
      file: "/attachments/CONFESSION_GUIDE_TAMIL.pdf",
    },
  ];

  const confessionSteps = [
    {
      id: "preparation",
      title: "Preparation for Confession",
      icon: faBook,
      show: "NO",
      content: `
        <h5>Before Going to Confession:</h5>
        <ol>
          <li><strong>Examination of Conscience</strong> - Reflect on your sins since your last confession</li>
          <li><strong>Contrition</strong> - Feel genuine sorrow for your sins</li>
          <li><strong>Firm Purpose of Amendment</strong> - Resolve not to sin again</li>
          <li><strong>Prayer</strong> - Ask the Holy Spirit for guidance</li>
        </ol>
        
        <h5>Questions to Ask Yourself:</h5>
        <ul>
          <li>Have I loved God with my whole heart?</li>
          <li>Have I taken the Lord's name in vain?</li>
          <li>Have I attended Mass every Sunday and Holy Day?</li>
          <li>Have I honored and respected my parents?</li>
          <li>Have I been angry or hateful toward others?</li>
          <li>Have I been impure in my thoughts, words, or actions?</li>
          <li>Have I stolen or cheated?</li>
          <li>Have I lied or gossiped?</li>
          <li>Have I been envious of others?</li>
          <li>Have I been greedy or materialistic?</li>
        </ul>
      `,
    },

    {
      id: "prayers",
      title: "Confession Prayers",
      icon: faBook,
      content: `
        <h5>Act of Contrition (Traditional)</h5>
        <div class="prayer-box">
          <p>
            O my God, I am heartily sorry for having offended Thee, 
            and I detest all my sins because of thy just punishments, 
            but most of all because they offend Thee, my God, 
            who art all good and deserving of all my love. 
            I firmly resolve with the help of Thy grace 
            to sin no more and to avoid the near occasion of sin. Amen.
          </p>
        </div>

        <h5>Act of Contrition (Alternative)</h5>
        <div class="prayer-box">
          <p>
            My God, I am sorry for my sins with all my heart. 
            In choosing to do wrong and failing to do good, 
            I have sinned against you whom I should love above all things. 
            I firmly intend, with your help, to do penance, 
            to sin no more, and to avoid whatever leads me to sin. 
            Our Savior Jesus Christ suffered and died for us. 
            In his name, my God, have mercy. Amen.
          </p>
        </div>

        <h5>Prayer Before Confession</h5>
        <div class="prayer-box">
          <p>
            Come, Holy Spirit, into my heart. 
            Enlighten my mind that I may know my sins. 
            Inspire me with true sorrow for them 
            and a sincere purpose of amendment. 
            Give me the courage to confess them with humility. 
            I trust in Your mercy and forgiveness. Amen.
          </p>
        </div>

        <h5>Prayer After Confession</h5>
        <div class="prayer-box">
          <p>
            Thank you, merciful Father, for the gift of forgiveness. 
            Thank you for Your unconditional love and mercy. 
            Help me to grow in holiness and to avoid sin. 
            May I always be grateful for the Sacrament of Reconciliation. 
            Through Christ our Lord. Amen.
          </p>
        </div>
      `,
    },
    {
      id: "examination",
      title: "Detailed Examination of Conscience",
      icon: faBook,
      content: `
        <h5>The Ten Commandments</h5>
        
        <div class="commandment-section">
          <h6>1. I am the Lord your God: you shall not have strange gods before me</h6>
          <ul>
            <li>Have I put anything before God (money, pleasure, success)?</li>
            <li>Have I practiced superstition or consulted fortune tellers?</li>
            <li>Have I denied my faith or been ashamed of it?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>2. You shall not take the name of the Lord your God in vain</h6>
          <ul>
            <li>Have I used God's name carelessly or blasphemed?</li>
            <li>Have I broken promises made in God's name?</li>
            <li>Have I cursed or used profane language?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>3. Remember to keep holy the Lord's Day</h6>
          <ul>
            <li>Have I missed Mass on Sundays or Holy Days without good reason?</li>
            <li>Have I been late or inattentive at Mass?</li>
            <li>Have I done unnecessary work on Sunday?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>4. Honor your father and your mother</h6>
          <ul>
            <li>Have I been disrespectful to my parents or guardians?</li>
            <li>Have I disobeyed legitimate authority?</li>
            <li>Have I neglected my family responsibilities?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>5. You shall not kill</h6>
          <ul>
            <li>Have I physically harmed anyone?</li>
            <li>Have I been angry, hateful, or held grudges?</li>
            <li>Have I encouraged or supported abortion?</li>
            <li>Have I endangered my own life or health recklessly?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>6. You shall not commit adultery</h6>
          <ul>
            <li>Have I been unfaithful in marriage?</li>
            <li>Have I engaged in sexual relations outside of marriage?</li>
            <li>Have I used contraception?</li>
            <li>Have I been immodest in dress or behavior?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>7. You shall not steal</h6>
          <ul>
            <li>Have I taken what doesn't belong to me?</li>
            <li>Have I cheated or been dishonest in business?</li>
            <li>Have I damaged others' property?</li>
            <li>Have I failed to return borrowed items?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>8. You shall not bear false witness against your neighbor</h6>
          <ul>
            <li>Have I lied or deceived others?</li>
            <li>Have I gossiped or spread rumors?</li>
            <li>Have I damaged someone's reputation?</li>
            <li>Have I failed to defend someone being slandered?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>9. You shall not covet your neighbor's wife</h6>
          <ul>
            <li>Have I entertained impure thoughts deliberately?</li>
            <li>Have I looked at others with lust?</li>
            <li>Have I viewed pornography?</li>
          </ul>
        </div>

        <div class="commandment-section">
          <h6>10. You shall not covet your neighbor's goods</h6>
          <ul>
            <li>Have I been jealous of others' possessions?</li>
            <li>Have I been greedy or materialistic?</li>
            <li>Have I been ungrateful for what I have?</li>
          </ul>
        </div>

        <h5>Other Areas to Consider</h5>
        <div class="commandment-section">
          <h6>Sins of Omission</h6>
          <ul>
            <li>Have I failed to help those in need?</li>
            <li>Have I neglected my prayer life?</li>
            <li>Have I failed to give good example?</li>
            <li>Have I been lazy or slothful?</li>
          </ul>
        </div>
      `,
    },
    {
      id: "procedure",
      title: "The Confession Procedure",
      icon: faCross,
      content: `
        <h5>Step-by-Step Guide:</h5>
        
        <div class="step-card">
          <h6>1. Enter the Confessional</h6>
          <p>Approach the priest with reverence. You may kneel or sit, face-to-face or behind a screen.</p>
        </div>

        <div class="step-card">
          <h6>2. Make the Sign of the Cross</h6>
          <p><em>"In the name of the Father, and of the Son, and of the Holy Spirit. Amen."</em></p>
        </div>

        <div class="step-card">
          <h6>3. Opening Statement</h6>
          <p><em>"Bless me, Father, for I have sinned. It has been [time period] since my last confession."</em></p>
        </div>

        <div class="step-card">
          <h6>4. Confess Your Sins</h6>
          <p>Tell your sins honestly and humbly. State the kind of sin and how many times (if mortal sins).</p>
          <p>Example: <em>"I lied three times. I missed Mass twice. I was angry with my family."</em></p>
        </div>

        <div class="step-card">
          <h6>5. Listen to the Priest</h6>
          <p>The priest may offer counsel and will assign a penance (prayers or good works).</p>
        </div>

        <div class="step-card">
          <h6>6. Express Contrition</h6>
          <p>Say an Act of Contrition prayer (see prayers section below).</p>
        </div>

        <div class="step-card">
          <h6>7. Receive Absolution</h6>
          <p>The priest will extend his hands and say the prayer of absolution. Make the sign of the cross.</p>
        </div>

        <div class="step-card">
          <h6>8. Dismissal</h6>
          <p>The priest will say: <em>"Give thanks to the Lord, for He is good."</em></p>
          <p>Respond: <em>"His mercy endures forever."</em></p>
          <p>Then: <em>"Go in peace."</em> Respond: <em>"Thanks be to God."</em></p>
        </div>

        <div class="step-card">
          <h6>9. Complete Your Penance</h6>
          <p>Immediately after confession, pray your assigned penance and thank God for His mercy.</p>
        </div>
      `,
    },
    {
      id: "benefits",
      title: "Benefits & Importance",
      icon: faCross,
      show: "NO",
      content: `
        <h5>Why Go to Confession?</h5>
        
        <div class="benefit-card">
          <h6>1. Jesus Instituted This Sacrament</h6>
          <p>
            "Receive the Holy Spirit. Whose sins you forgive are forgiven them, 
            and whose sins you retain are retained." (John 20:22-23)
          </p>
        </div>

        <div class="benefit-card">
          <h6>2. Spiritual Healing</h6>
          <p>
            Confession heals the soul just as medicine heals the body. 
            It restores our relationship with God and the Church.
          </p>
        </div>

        <div class="benefit-card">
          <h6>3. Peace of Conscience</h6>
          <p>
            Experience the profound peace that comes from knowing you are forgiven 
            and reconciled with God.
          </p>
        </div>

        <div class="benefit-card">
          <h6>4. Grace to Avoid Sin</h6>
          <p>
            The sacrament provides actual grace to help you resist temptation 
            and grow in holiness.
          </p>
        </div>

        <div class="benefit-card">
          <h6>5. Spiritual Direction</h6>
          <p>
            The priest can offer guidance and wisdom for your spiritual journey.
          </p>
        </div>

        <div class="benefit-card">
          <h6>6. Community Reconciliation</h6>
          <p>
            Sin affects not just our relationship with God, but with the entire Church. 
            Confession reconciles us with the community of believers.
          </p>
        </div>

        <h5>Frequency of Confession</h5>
        <ul>
          <li><strong>Required:</strong> At least once a year (during Lenten season) and before receiving Holy Communion if conscious of mortal sin</li>
          <li><strong>Recommended:</strong> Monthly or more frequently</li>
          <li><strong>For Growth:</strong> Weekly or bi-weekly confession helps develop spiritual discipline</li>
        </ul>

        <h5>Types of Sin</h5>
        <div class="sin-types">
          <div class="sin-type-card">
            <h6>Mortal Sin</h6>
            <ul>
              <li>Grave matter</li>
              <li>Full knowledge</li>
              <li>Deliberate consent</li>
            </ul>
            <p><em>Must be confessed before receiving Communion</em></p>
          </div>
          <div class="sin-type-card">
            <h6>Venial Sin</h6>
            <ul>
              <li>Less serious matter</li>
              <li>Or done without full knowledge/consent</li>
            </ul>
            <p><em>Recommended to confess for spiritual growth</em></p>
          </div>
        </div>
      `,
    },
  ];

  const handleDownloadPDF = () => {
    const selectedLang = languages.find(
      (lang) => lang.code === selectedLanguage
    );
    if (selectedLang?.file) {
      const link = document.createElement("a");
      link.href = selectedLang.file;
      link.download = `Confession_Guide_${selectedLang.name}.pdf`;
      link.click();
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <React.Fragment>
      {/* Menu */}
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>
      {/* Title Section with Overlay */}
      <section className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">
              <FontAwesomeIcon icon={faCross} className="me-3" />
              Guide to Sacrament of Confession
            </h1>
          </div>
        </div>
      </section>
      <div className="confession-guide-page">
        {/* Header 
        <div className="guide-header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <h1 className="page-title">
                  <FontAwesomeIcon icon={faCross} className="me-3" />
                  Sacrament of Confession Guide
                </h1>
                <p className="page-subtitle">
                  A Complete Guide to the Sacrament of Reconciliation
                </p>
              </div>
              <div className="col-lg-4 text-lg-end"></div>
            </div>
          </div>
        </div>*/}

        <div className="language-selector-section">
          <div className="container">
            <div className="language-selector-card d-flex align-items-stretch justify-content-center">
              <FontAwesomeIcon
                icon={faLanguage}
                className="language-icon me-2"
              />

              <label htmlFor="language-select" className="mb-0 me-2">
                Select Language:
              </label>

              <select
                id="language-select"
                className="form-select form-select-sm me-3"
                value={selectedLanguage}
                onChange={(e) => setSelectedLanguage(e.target.value)}
              >
                {languages.map((lang) => (
                  <option key={lang.code} value={lang.code}>
                    {lang.name}
                  </option>
                ))}
              </select>

              <button
                className="btn btn-outline-light me-2"
                onClick={handleDownloadPDF}
                aria-label="Download PDF"
              >
                <FontAwesomeIcon icon={faDownload} className="me-2" />
              </button>

              <button
                className="btn btn-outline-light"
                onClick={handlePrint}
                aria-label="Print Guide"
              >
                <FontAwesomeIcon icon={faPrint} className="me-2" />
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="guide-content">
          <div className="container">
            {/* Introduction */}
            <div className="introduction-section">
              <div className="intro-card">
                <h3>Welcome to the Sacrament of Reconciliation</h3>
                <p>
                  The Sacrament of Confession, also known as the Sacrament of
                  Reconciliation or Penance, is one of the seven sacraments of
                  the Catholic Church. Through this sacrament, we receive God's
                  mercy and forgiveness for our sins.
                </p>
                <p>
                  <strong>
                    "If we confess our sins, he is faithful and just and will
                    forgive us our sins and purify us from all unrighteousness."
                  </strong>{" "}
                  (1 John 1:9)
                </p>
              </div>
            </div>

            {/* Accordion Sections */}
            <div className="confession-sections">
              {confessionSteps
                .filter((step) => step.show !== "NO")
                .map((step) => (
                  <div key={step.id} className="section-card">
                    <div
                      className="section-header"
                      onClick={() => toggleSection(step.id)}
                    >
                      <div className="section-title">
                        <FontAwesomeIcon
                          icon={step.icon}
                          className="section-icon"
                        />
                        <h4>{step.title}</h4>
                      </div>
                      <FontAwesomeIcon
                        icon={
                          expandedSection === step.id
                            ? faChevronUp
                            : faChevronDown
                        }
                        className="toggle-icon"
                      />
                    </div>

                    {expandedSection === step.id && (
                      <div className="section-content">
                        <div
                          dangerouslySetInnerHTML={{ __html: step.content }}
                        />
                      </div>
                    )}
                  </div>
                ))}
            </div>

            {/* Additional Resources */}
            <div className="resources-section">
              <h3>Additional Resources</h3>
              <div className="row">
                <div className="col-md-6">
                  <div className="resource-card">
                    <h5>Confession Times</h5>
                    <p>
                      Contact your local parish for confession times. Most
                      parishes offer confession on Saturdays and by appointment.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="resource-card">
                    <h5>Questions?</h5>
                    <p>
                      If you have questions about confession, speak with your
                      parish priest. They are always happy to help and guide
                      you.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Note */}
            <div className="footer-note">
              <p>
                <em>
                  "There is more joy in heaven over one sinner who repents than
                  over ninety-nine righteous persons who need no repentance." -
                  Luke 15:7
                </em>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <FooterPanel />
    </React.Fragment>
  );
};

export default ConfessionGuidePage;
